<template>
    <div class="appVersion">
      <div class="header">
        <div class="title">APP版本信息</div>
        <div class="right">
            <a-space>
                <ButtonField text="📥下载二维码" @click="openQrCodeModal" secondary />
                <ButtonField text="➕新增" primary @click="add"/>
            </a-space>
        </div>
      </div>

        <Modal v-if="qrCodeModalVisible" v-model="qrCodeModalVisible"
               :visible="qrCodeModalVisible"
               :title="'下载二维码'"
               :showFooter="false"
               :overlayOpacity="0.5"
               @update:visible="qrCodeModalVisible = $event"
               :contentWidth="isMobile ? '90%' : '400px'"
        >
            <a href="/zaoyang-download-app.png" target="_blank">
              <img src="/zaoyang-download-app.png" alt="" style="width: 100%" />
            </a>
        </Modal>

        <Modal v-if="addVisible" v-model="addVisible"
               :visible="addVisible"
               :title="'新增版本'"
               :showFooter="false"
               :overlayOpacity="0.5"
               @update:visible="addVisible = $event">
            <form>
                <div class="form-group">
                    <InputField labelWidth="10%" style="margin: 0.5rem 0.2rem;" label="名称" type="text" id="name"
                                :modelValue="form.name" required placeholder="请输入名称"
                                @update:modelValue="(value) => handleModelValueUpdate('name', value)"/>
                </div>
                <div class="form-group">
                    <InputField labelWidth="10%" style="margin: 0.5rem 0.2rem;" label="路径" type="text" id="url"
                                :modelValue="form.url" required placeholder="请输入路径"
                                @update:modelValue="(value) => handleModelValueUpdate('url', value)"/>
                </div>
                <div class="form-group">
                    <RadioField
                            name="platformType"
                            id="platformType"
                            :options="radioOptions"
                            labelWidth="9%"
                            label="类型"
                            :modelValue="form.platformType"
                            @update:modelValue="(value) => handleModelValueUpdate('platformType', value)"
                    />
                </div>
                <div class="form-group">
                    <InputField labelWidth="10%" style="margin: 0.5rem 0.2rem;" label="备注" type="text" id="remark"
                                :modelValue="form.remark" required placeholder="请输入备注"
                                @update:modelValue="(value) => handleModelValueUpdate('remark', value)"/>
                </div>
                <div style="text-align: center">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                    </a-space>
                </div>
            </form>
        </Modal>

        <Tablelist
                :showCheckbox="showCheckbox"
                :list="workOrders"
                :columns="tableColumns"
                :tableTitle="'APP版本管理'"
                @refresh="handleRefresh"
                @settings="handleSettings"
                @selection-change="handleSelectionChange"
                @page-change="handlePageChange"
                @action="handleAction"
        />
    </div>
</template>

<script>
import request from "@/api/request";
import Tablelist from '@/components/water-affairs-style/table-list.vue';
import Modal from '@/components/water-affairs-style/modal.vue';

function add(data) {
    return request({
        url: "/basic-service/softVersion/add",
        method: "post",
        data,
    });
}

// function edit(data) {
//     return request({
//         url: "/basic-service/softVersion/update",
//         method: "post",
//         data,
//     });
// }

function fetchList(params) {
  return request({
    url: "/basic-service/softVersion/list",
    method: "get",
    params,
  });
}

function remove(data) {
  return request({
    url: "/basic-service/softVersion/del",
    method: "post",
    data,
  });
}

export default {
  data() {
    return {
      form:{
          name:'',
          url:'',
          platformType:''
      },
      loading: false,
      list: [],
      isMobile: window.innerWidth < 768,
      visible: false,
      showCheckbox: false,
      currentPage: 1,
      itemsPerPage: 10,
      workOrders: [],
      qrCodeModalVisible: false,
      addVisible:false,
      createModalButtons:[],
      tableColumns: [
          {
              key: 'name',
              title: '名称',
              field: 'name'
          },
          {
              key: 'platformType',
              title: '类型',
              field: 'platformType'
          },
          {
              key: 'url',
              title: '路径',
              field: 'url',
              style: { width: '250px' },
              ellipsis: true
          },
          {
              key: 'actions',
              title: '操作',
              render: {
                  view: false, edit: true, delete: true
              }
          }
      ],
      radioOptions:[
          { name: 'android', value: 'android'},
          { name: 'ios', value: 'ios'}
      ]
    };
  },
  components: {
      Tablelist,
      Modal
  },
  mounted() {
    this.getList();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
  },
  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
      cancel(){
          this.addVisible = false
      },
      handleSubmit(){
          console.log("提交::",this.form)

          add({
              ...this.form,
          }).then(() => {
              this.cancel();
          });
      },
      handleResize() {
          this.isMobile = window.innerWidth < 768;
      },
      openQrCodeModal() {
          this.qrCodeModalVisible = true;
      },
      handleRefresh() {
          console.log('刷新表格数据');
      },
      handleSettings() {
          console.log('打开设置');
      },
      handleSelectionChange(selection) {
          console.log('选择变更:', selection);
      },
      handlePageChange(page) {
          console.log('页码变更:', page);
          // 加载对应页码的数据
          this.loadData(page);
      },
      loadData(page) {
          // 模拟加载数据
          console.log(`加载第 ${page} 页数据`);
      },
      // 处理操作按钮点击事件
      handleAction(actionInfo) {
          const { type, id } = actionInfo;
          switch(type) {
              case 'view':
                  this.viewWorkOrder(id);
                  break;
              case 'edit':
                  this.edit(actionInfo);
                  break;
              case 'delete':
                  this.deleteText(actionInfo);
                  break;
          }
      },
      viewWorkOrder(id) {
          console.log('查看工单:', id);
          // 这里可以打开查看工单详情的页面或弹窗
      },
      deleteWorkOrder(id) {
          // 确认删除
          if (confirm('确定要删除这个工单吗？')) {
              console.log('删除工单:', id);
              this.workOrders = this.workOrders.filter(item => item.id !== id);
              console.log('删除后的工单列表:', this.workOrders);
              this.$emit('refresh');
          }
      },
      getList() {
        this.loading = true;
        fetchList({
          pageNum: 1,
          pageSize: 99,
        }).then((res) => {
            if (Array.isArray(res.list)) {
              this.workOrders = Object.freeze(res.list);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      deleteText(text) {
        const that = this;
        this.$confirm({
          title: "确认要删除吗？",
          onOk() {
            remove({
              id: text.id,
            }).then(() => {
              that.getList();
            });
          },
        });
      },
      add() {
          this.addVisible = true;
      },
      edit(text) {
          this.addVisible = true;
          if (text) {
              this.form = text.item;
              console.log("编辑::",this.form)
          }
      },
  },
};
</script>


<style lang="less" scoped>
.appVersion{

  .btn {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    cursor: pointer;
    border: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .btn-primary {
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    color: #0a0e27;
    font-weight: 600;
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.3);
  }

  .btn-secondary {
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.3);
    color: #00ff96;
  }

  .btn-secondary:hover {
    background: rgba(0, 255, 150, 0.1);
    border-color: #00ff96;
  }

  & > .header {
    color: #00ff96;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    height: 50px;
    margin-bottom: 10px;
  }

  /* 表单样式 */
  .form-group {
    margin-bottom: 1.5rem;
  }

}


</style>
